.page {
  min-height: calc(100dvh - 3.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper {
  display: grid;
  grid-template-columns: 5fr 7fr;
  max-width: 780px;
  margin: 0 auto;
  border-radius: var(--mantine-radius-sm);
  overflow: hidden;
  border: 1px solid var(--mantine-color-default-border);
  box-shadow: var(--mantine-shadow-lg);
}

.brandPanel {
  background: linear-gradient(
    155deg,
    var(--mantine-color-dark-5) 0%,
    var(--mantine-color-dark-8) 100%
  );
  padding: var(--mantine-spacing-xl);
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  min-height: 420px;
}

.brandPanel::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      ellipse at 20% 25%,
      rgba(217, 194, 153, 0.14) 0%,
      transparent 55%
    ),
    radial-gradient(
      ellipse at 80% 80%,
      rgba(23, 31, 33, 0.45) 0%,
      transparent 50%
    );
}

.eyebrow {
  position: relative;
  z-index: 1;
  font-size: var(--mantine-font-size-xs);
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: var(--mantine-color-gray-4);
  margin-bottom: var(--mantine-spacing-md);
}

.brandTitle {
  position: relative;
  z-index: 1;
  line-height: 1.1;
}

.divider {
  position: relative;
  z-index: 1;
  width: 36px;
  height: 2px;
  background-color: var(--mantine-color-gray-4);
  margin: var(--mantine-spacing-lg) 0;
}

.brandTagline {
  position: relative;
  z-index: 1;
  line-height: 1.65;
  max-width: 28ch;
}

.formPanel {
  padding: var(--mantine-spacing-xl);
  padding-left: calc(var(--mantine-spacing-xl) * 1.5);
  background-color: light-dark(
    var(--mantine-color-white),
    var(--mantine-color-dark-6)
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (max-width: 48em) {
  .wrapper {
    grid-template-columns: 1fr;
    max-width: 420px;
  }

  .brandPanel {
    min-height: 160px;
    padding: var(--mantine-spacing-lg);
  }

  .formPanel {
    padding: var(--mantine-spacing-lg);
  }
}
